import template from "./invoice-transactions.html";
import "./invoice-transactions.less";

const invoiceTransactionsModule = "vesl.components.invoice-transactions";

export default angular
	.module(invoiceTransactionsModule, [])
	.component("invoiceTransactions", {
		bindings: {
			invoice: "<"
		},
		template
	})
	.name;
